"use client";

import { Lock, ShieldCheck, CreditCard } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WooCommerceCheckoutBlock } from "@/integrations/wordpress/WooCommerceCheckoutBlock";
export default function Checkout() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3133" id="checkoutcontent" className="bg-background text-foreground py-24 px-6 md:px-10 lg:px-16 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-lg blur-[120px] opacity-10 pointer-events-none" style={{
      backgroundColor: "var(--primary)"
    }} />

      <div className="max-w-[1400px] mx-auto relative">
        {}
        <nav aria-label="breadcrumb" className="font-mono text-[11px] tracking-[0.2em] uppercase mb-16 flex items-center gap-3" style={{
        color: "var(--muted-foreground)"
      }}>
          <Link to="/HomePage" className="hover:text-foreground transition-colors">
            HOME
          </Link>
          <span style={{
          color: "var(--border)"
        }}>/</span>
          <Link to="/CartPage" className="hover:text-foreground transition-colors">
            CART
          </Link>
          <span style={{
          color: "var(--border)"
        }}>/</span>
          <span className="text-foreground">CHECKOUT</span>
        </nav>

        {}
        <div ref={headerRef} className={`mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-3 mb-8">
            <Lock className="w-3.5 h-3.5" style={{
            color: "var(--primary)"
          }} />
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase" style={{
            color: "var(--primary)"
          }}>
              — SECURE PAYMENT
            </span>
          </div>

          <h1 className="font-default font-bold text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight uppercase">
            FINALIZE
            <br />
            YOUR
            <br />
            LUSH LOOK.
          </h1>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-10">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-3.5 h-3.5" style={{
              color: "var(--primary)"
            }} />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                SSL SECURED
              </span>
            </div>
            <div className="flex items-center gap-2">
              <CreditCard className="w-3.5 h-3.5" style={{
              color: "var(--primary)"
            }} />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                PREMIUM PAYMENTS
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Lock className="w-3.5 h-3.5" style={{
              color: "var(--primary)"
            }} />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                DATA PROTECTED
              </span>
            </div>
          </div>

          <div className="mt-10 h-px w-full" style={{
          backgroundColor: "var(--border)"
        }} />
        </div>

        {}
        <div ref={contentRef} className={`transition-all duration-1000 ease-out delay-200 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative p-6 md:p-10 lg:p-12 backdrop-blur-xl border shadow-4xl rounded-lg" style={{
          backgroundColor: "hsla(0, 0%, 100%, 0.03)",
          borderColor: "var(--border)"
        }}>
            {}
            <div className="absolute top-0 left-0 w-16 h-px" style={{
            backgroundColor: "var(--primary)"
          }} />
            <div className="absolute top-0 left-0 w-px h-16" style={{
            backgroundColor: "var(--primary)"
          }} />

            <WooCommerceCheckoutBlock />
          </div>

          {}
          <div className="mt-10 flex flex-col items-center text-center gap-2">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{
            color: "var(--muted-foreground)"
          }}>
              ENCRYPTED FOR YOUR PRIVACY
            </p>
            <p className="font-serif italic text-sm" style={{
            color: "var(--muted-foreground)"
          }}>
              Your style journey is safe with Lush Fashion.
            </p>
          </div>
        </div>
      </div>
    </section>;
}